<template lang="html">
  <div class="welcome">
    <div class="welcome--header">
      <h1 class="display-1">Ments meg minket! </h1>
      <h2 class="headline">Alapítvány az állatokért</h2>

      <router-link
        tag="div"
        class="sosicon"
        v-if="helpNeeded"
        :to="{name:'helpus', query:{selectedComp:'Surgos'}}"
      >
        <v-icon
        large
        color="pink"
        >
        mdi-alert-rhombus-outline
        </v-icon>
        <span>SOS</span>
        <v-icon
        large
        color="pink"
        >
        mdi-alert-rhombus-outline
        </v-icon>
      </router-link>
    </div>


    <Banner />


  </div>
</template>

<script>
import Banner from './Banner.vue'

export default {
  data(){
    return{
      helpNeeded: this.$store.getters.allAnimals.filter(a=>a.colorcode==="pink").length>0 ? true : false,
    }
  },
  mounted(){

  },

  components: {
    Banner,
  }
}
</script>

<style lang="scss" scoped>
.welcome--header{
  text-align: center;
  color: $darkbrown;
}
.sosicon{
  color: #E91E63;
  font-size: 20px;
  font-weight: bold;
  margin-top: 10px;

  &:hover{
    cursor: pointer;
    color: #C51162;

    .v-icon{
      color: #C51162 !important;
    }
  }

}
</style>
